require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-build-web-app-marketing-promotion.json") })
        }
      }, "path---blog-how-to-build-web-app-marketing-promotion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-build-web-app-marketing-promotion!./.cache/json/blog-how-to-build-web-app-marketing-promotion.json
// module id = 864
// module chunks = 231608221292675